module.exports = __webpack_public_path__ + "static/media/wifi.0190ff8c.svg";